import React from 'react';
import PropTypes from 'prop-types';
import Title from 'common/Title';
import css from './SurveyDetails.css'
import SurveyInstructions from 'common/ReadMoreLessText';
import SurveyDate from './SurveyDate';
import striptags from "striptags";

export default class SurveyDetails extends React.Component {

    getProgressSurveyDate(surveyDate, dateLabel) {
      return surveyDate ?
          <SurveyDate
              surveyDate={surveyDate}
              dateLabel={dateLabel}
          />
          : null;
    }

  static stripTagsFromSurveyInstructions(surveyInstructions) {
      return striptags(surveyInstructions, ['a', 'b', 'strong', 'u', 'i', 'em']);
  }

    render() {
        const selectedSurvey = this.props.survey;
        return (
            <div className={css['survey-details']}>
                <Title text={selectedSurvey.surveyName} color="black" fontSize="16px" lineHeight="24px"/>
                {this.getProgressSurveyDate(this.props.surveyUpdatedDate, 'SAVED')}
                {this.getProgressSurveyDate(selectedSurvey.formattedDueDate, 'DUE')}
                <SurveyInstructions text={SurveyDetails.stripTagsFromSurveyInstructions(selectedSurvey.surveyInstructions)} allowHtml={true} />
            </div>
        );
    }
}

SurveyDetails.propTypes = {
    survey: PropTypes.object.isRequired,
    surveyUpdatedDate: PropTypes.string
};
